import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PinchIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pinch"}/>
}
